import React from 'react';
import Layout from "../../../components/Wrappers/Layout";
import UserManagementList from './UserManagementList';
import UserManagementFilter from './UserManagementFilter';

function BankUserManagement() {
  return (
    <Layout>
        <UserManagementFilter />
        <UserManagementList />
    </Layout>
  )
}

export default BankUserManagement